import React, { useState, useEffect } from 'react';
import { FormGroup, Col } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

export default function Compositions({ nestIndex, fields, compositionListObj, onCompositionChange, onErrorChange, highlightedKey }) {
  const { t } = useTranslation('common');

  const [compositionFields, setCompositionFields] = useState(
    Array.isArray(fields.composition) && fields.composition.length > 0 ? fields.composition : [{ percentage: null, composition: null }],
  );
  const [error, setError] = useState({ percentageError: false, compositionError: [] });

  const validateTotalPercentage = () => {
    const totalPercentage = compositionFields.reduce((acc, curr) => acc + (parseFloat(curr.percentage) || 0), 0);

    // Show the error only if totalPercentage is not 100 and there is some percentage value present
    const percentageError = totalPercentage !== 100 && totalPercentage > 0;

    const compositionError = compositionFields.map((field) => field.percentage && !field.composition);

    setError({ percentageError, compositionError });
    onErrorChange(nestIndex, percentageError || compositionError.some((err) => err));
  };

  useEffect(() => {
    if (highlightedKey?.includes('composition')) {
      validateTotalPercentage();
    }
  }, [compositionFields]);

  const handleAddComposition = () => {
    const newCompositionFields = [...compositionFields, { percentage: null, composition: null }];
    setCompositionFields(newCompositionFields);
    onCompositionChange(newCompositionFields); // Notify parent
  };

  const handleRemoveComposition = (index) => {
    const updatedFields = compositionFields.filter((_, i) => i !== index);
    setCompositionFields(updatedFields);
    onCompositionChange(updatedFields);
  };

  const handlePercentageChange = (val, index) => {
    const updatedFields = [...compositionFields];
    updatedFields[index].percentage = parseFloat(val) || '';
    setCompositionFields(updatedFields);
    onCompositionChange(updatedFields);
  };

  const handleChangeComposition = (val, index) => {
    const updatedFields = [...compositionFields];
    updatedFields[index].composition = val;
    setCompositionFields(updatedFields);
    onCompositionChange(updatedFields);
  };

  const customStyles = {
    option: (provided) => ({
      ...provided,
      padding: '5px 10px',
    }),
    control: () => ({
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      borderBottom: '1px solid #848484',
    }),
    singleValue: (provided) => ({
      ...provided,
      opacity: 1,
      transition: 'opacity 300ms',
    }),
    menu: (provided) => ({
      ...provided,
      margin: '-1px 0 0 0',
      border: '1px solid #848484',
      borderRadius: 0,
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      color: '#555',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#848484',
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  };
  const getPercentageClassName = () => {
    return highlightedKey?.includes('composition') ? 'highlighted-field flex-one-third mr-3' : 'flex-one-third mr-3';
  };
  const getCompositionClassName = () => {
    return highlightedKey?.includes('composition') ? 'highlighted-field flex-fill' : 'flex-fill';
  };
  return (
    <>
      {compositionFields.map((item, k) => (
        <Col key={k} lg={6}>
          <div className="d-flex align-items-start">
            <FormGroup className={fields?.keysActuallyChanged?.includes('composition') ? 'key-to-check-field flex-one-third mr-3' : getPercentageClassName()}>
              <div className="input-group form-floating-label fixed-label">
                <input
                  type="number"
                  name={`bomForm[${nestIndex}].composition[${k}].percentage`}
                  value={item.percentage || ''}
                  placeholder={t('COMPOSITION.PERCENTAGE')}
                  className="form-control"
                  min="0"
                  max="100"
                  onChange={(e) => handlePercentageChange(e.target.value, k)}
                  disabled={!highlightedKey?.includes('composition') || fields?.keysActuallyChanged?.includes('composition')}
                />
                <label className="asterisk-req">{t('COMPOSITION.PERCENTAGE')}</label>
              </div>
              {error.percentageError && k === compositionFields.length - 1 && (
                <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.TOTAL_PERCENTAGE_VALIDATION')}</span>
              )}
            </FormGroup>

            <FormGroup className={fields?.keysActuallyChanged?.includes('composition') ? 'key-to-check-field flex-fill' : getCompositionClassName()}>
              <div className="custom-react-select">
                <label className="field-lbl asterisk-req">{t('COMPOSITION.COMPOSITION')}</label>
                <Select
                  name={`bomForm[${nestIndex}].composition[${k}].composition`}
                  options={compositionListObj}
                  value={compositionListObj?.filter((data) => item?.composition?.includes(data?._id)) || ''}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  styles={customStyles}
                  onChange={(val) => handleChangeComposition(val._id, k)}
                  placeholder={t('COMPOSITION.COMPOSITION')}
                  isDisabled={!highlightedKey?.includes('composition') || fields?.keysActuallyChanged?.includes('composition')}
                />
              </div>
              {error?.compositionError[k] && <span className="error-message">{t('BOM_TYPE_GROUP_VIEW.VALIDATION_ERROR.COMPOSITION_FOR_PERCENTAGE')}</span>}
            </FormGroup>
            {highlightedKey?.includes('composition') && !fields?.keysActuallyChanged?.includes('composition') && (
              <div className="d-flex mt-25">
                {k === compositionFields.length - 1 && (
                  <a href={() => false} onClick={handleAddComposition} className="btn btn-outline" aria-label="button">
                    <span className="icon-add" />
                  </a>
                )}

                {compositionFields.length > 1 && (
                  <a href={() => false} onClick={() => handleRemoveComposition(k)} className="btn btn-outline" aria-label="button">
                    <span className="icon-delete" />
                  </a>
                )}
              </div>
            )}
          </div>
        </Col>
      ))}
    </>
  );
}
